<div class="dragDropContainer">
  <div *ngIf="state.isLoading">
    <p class="loader">
      <img src="{{loaderState.imagePath }}" alt="loader" />
    </p>
  </div>
  <div *ngIf="!state.fileUploadLoader; else loader">
  <div class="dragDropContainer__dropSpace" *ngIf="!state.isLoading">
    <div kngDnDDirective (fileDropped)="onFileDropped($event)"
      *ngIf="!state.isError && state.isSuccessClient && !state.isSuccessServer">
      <img src={{state.dragDropImage.iconPath}} alt={{state.dragDropImage.altText}} tabindex="0"
        class="dragDropContainer__dragDropImage">
      <p class="dragDropContainer__dragDrop" tabindex="0"> {{state.dragDropSection}} </p>
      <p class="dragDropContainer__or " tabindex="0"> {{state.or}} </p>
      <button class="uploadButton" tabindex="0" (keypress)="fileOpen.click()">
        <input #fileOpen type='file' class="uploadInput" id="selectFile" (change)="fileBrowseHandler($event)" tabindex="-1" />
        {{state.uploadButtons.chooseFile}}
      </button>
      <div *ngFor="let file of files">
        <div class="fileName" tabindex="0" #file>{{ file.name }}</div>
      </div>
    </div>
    <div *ngIf="state.isError">
      <img class="dragDropContainer__errorImage" src={{state.errorImage.iconPath}} alt={{state.errorImage.altText}} tabindex="0">
      <p class="dragDropContainer__errorHeading" tabindex="0">{{state.errorHeading}}</p>
      <p class="dragDropContainer__errorSubheading" tabindex="0">{{state.errorSubHeading}}</p>
      <button *ngIf="!state.isSuccessClient && !state.isSuccessServer" class="uploadButton" tabindex="0"
        (click)="onReplaceFileBtnClick()">
        {{state.uploadButtons.replaceFile}}
      </button>
      <button *ngIf="state.isSuccessClient && !state.isSuccessServer" class="uploadButton" tabindex="0"
        (click)="onTryAgainBtnClick()">
        {{state.uploadButtons.tryAgain}}
      </button>
    </div>
  </div>
  <div class="dragDropContainer__dropSpace" *ngIf="state.isSuccessClient && state.isSuccessServer && !state.isError">
    <img class="dragDropContainer__successImage" src={{state.successImage.iconPath}} alt={{state.successImage.altText}} tabindex="0">
    <p class="dragDropContainer__uploadSuccessful" tabindex="0"> {{state.successMessage}} </p>
  </div>
 </div>
 <div>
  <ng-template #loader>
    <div class="uploadfile-loader">
    <div class="loader-icon">
      <img src="{{fileUploadLoaderState.imagePath}}">
    </div>
    <div>
      <p><b>{{state.fileUploadProgressText}}</b></p>
    </div>
  </div>
  </ng-template>
 </div>
</div>